import React from 'react';
import './index.scss';
import AlertSystemTable from './Table';

const AlertSystem = () => (
  <div className="tab-content h-auto d-flex flex-fill flex-column alert-system">
    <AlertSystemTable />
  </div>
);

export default AlertSystem;
